<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="150px">
    <div class="order-main container">
      <div class="form-item-title">备注及附件</div>
      <el-row>
        <el-col :span="24">
          <el-form-item label="附件:">
            <div v-if="isUploadBtn" style="width: 60%">
              <file-upload
                :limit="5"
                :file-size="30"
                :upload-url="uploadUrl"
                :verify="true"
                :tips-message="tipsMessage"
                :upload-image="true"
                :accept="'.jpg,.jpeg,.png,.pdf'"
                :if-upload-btn="isUploadBtn"
                :url="supplierOfferAttachmentListShow"
                @getFileInfo="getFileInfo"
              />
            </div>
            <div>
              <el-tooltip
                v-for="item of supplierOfferAttachmentListShow"
                :key="item.fileUrl"
                effect="dark"
                :content="item.fileName"
                placement="bottom"
                :disabled="checkTextOverflow(item.fileName)"
              >
                <span class="file-name" @click="downloadFile(item)">
                  {{ item.fileName }}
                </span>
              </el-tooltip>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注:" prop="offerRemark">
            <el-input
             v-if="routeQueryType == 'offer'"
              v-model="form.offerRemark"
              type="textarea"
              :rows="3"
              placeholder="请输入备注"
              :maxlength="500"
              show-word-limit
            />
            <span v-else>{{ routeData.offerRemark }}</span>
          </el-form-item>
          
        </el-col>
      </el-row>
    </div>
    <div class="order-main container">
      <div class="form-item-title">联系方式</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人:" prop="offerRealName">
            <el-input v-if="routeQueryType == 'offer'" v-model="form.offerRealName" placeholder="请输入联系人" />
            <span v-else>{{ routeData.offerRealName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式:" prop="offerMobile">
            <el-input v-if="routeQueryType == 'offer'" v-model="form.offerMobile" placeholder="请输入联系方式" />
            <span v-else>{{ routeData.offerMobile }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="邮箱:" prop="offerEmail">
            <el-input v-if="routeQueryType == 'offer'" v-model="form.offerEmail" placeholder="请输入邮箱" />
            <span v-else>{{ routeData.offerEmail }}</span>
          </el-form-item>
        </el-col>
       
      </el-row>
    </div>
  </el-form>
</template>

<script>
import api from '@/modules/projectA/api/order';
import FileUpload from '@/modules/projectA/pages/product/components/fileUpload.vue';
import {
  mobilePhone,
  isEmailAvailable,
} from '@/modules/projectA/utils/validate';
export default {
  components: {
    FileUpload,
  },
  props: {
    isUploadBtn: {
      type: Boolean,
      default: false,
    },
    routeQueryType: {
      type: String,
      default: '',
    },
    routeData: {
      type: Object,
      default: () => {},
    },
    supplierOfferAttachmentListShow: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  watch: {
    mall_userInfo: {
      handler(newVal) {
        if (newVal.realName && !this.routeData.offerRealName) {
          console.log(newVal, 'newVal123123123123123');
          const { realName = '', mobile = '', email = '' } = newVal;
          this.form.offerEmail = email;
          this.form.offerMobile = mobile;
          this.form.offerRealName = realName;
        }
      },
      immediate: true,
    },
  },
  created() {
    console.log(this.routeData, 'routeData');
    if(this.routeQueryType == 'offer' && this.routeData.realName){
      const { offerRealName = '', offerMobile = '', offerEmail = '' } = this.routeData;
      this.form.offerEmail = offerEmail;
          this.form.offerMobile = offerMobile;
          this.form.offerRealName = offerRealName;
    }
  },
  data() {
    const isEmailAvailableSelf = (rule, value, callback) => {
      if (!value) {
        // 非必填项为空时不报错，直接通过
        return callback();
      }
      isEmailAvailable(rule, value, callback)
    }
    return {
      uploadUrl: api.enquiryPrice_fileUpload,
      offerAttachmentCount: 0,
      supplierOfferAttachmentAOList: [],
      tipsMessage:
        '最多上传5个附件，格式仅支持.jpg/.jpeg/.png/.pdf，每个附件大小不超过30M。',
      form: {
        offerRemark: '',
        offerEmail: '',
        offerRealName: '',
        offerMobile: '',
      },
      rules: {
        offerEmail: [{required: false, validator: isEmailAvailableSelf, trigger: 'blur' }],
        offerRealName: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        offerMobile: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { validator: mobilePhone, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    submitForm(){
        return new Promise((resolve,reject)=>{
        this.$refs.form.validate((valid) => {
            if (valid) {
                resolve({
                    valid:true,
                    form:this.form,
                    supplierOfferAttachmentAOList:this.supplierOfferAttachmentAOList,
                    offerAttachmentCount:this.offerAttachmentCount
                });
            }else{
                reject({
                    valid:false,
                    form:this.form,
                    supplierOfferAttachmentAOList:this.supplierOfferAttachmentAOList,
                    offerAttachmentCount:this.offerAttachmentCount
                });
            }
        });
    }) 
    },
    getFileInfo(fileList) {
      this.offerAttachmentCount = fileList.length;
      this.supplierOfferAttachmentAOList = fileList.map((item) => ({
        attachmentUrl: item.fileUrl,
        attachmentName: item.fileName,
      }));
    },
    checkTextOverflow(str) {
      let count = 0; // 初始化字节数递加变量并获取字符串参数的字符个数
      if (str) {
        // 如果存在字符串，则执行
        for (let i = 0; i < str.length; i++) {
          if (str.charCodeAt(i) > 255) {
            // 字符编码大于255，说明是双字节字符(即是中文)
            count += 2;
          } else {
            count++;
          }
        }
      }
      return count <= 20;
    },
    downloadFile(fileObj) {
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(fileObj.fileUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileObj.fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
  },
};
</script>

<style lang="scss" scoped>

.file-name{
  color: #2587ff;
  cursor: pointer;
  display: block;
}
</style>
